<template>
  <div>
    <question-card
      ref="questionCardRef"
      v-if="activeQuestion"
      show-buttons
      :question="activeQuestion"
    ></question-card>
  </div>
</template>
<script>
import { webSocketService } from "@/services/question";
import QuestionCard from "@/components/QuestionCard";
import { Question } from "@/shared/question";

export default {
  name: "question-controller",
  components: { QuestionCard },
  data() {
    return {
      activeQuestion: null,
      questionHistory: []
    };
  },
  methods: {
    backQuestion() {
      this.$refs.questionCardRef.clear();
      const previous = this.questionHistory.pop();
      this.loadQuestion(previous.id);
    },
    loadQuestion(questionId) { // eslint-disable-line
      this.$refs.questionCardRef.clear();
    }
  },
  created() {
    webSocketService.bindOnMessage(event => {
      this.activeQuestion = Question.from(event.data);
    });
  }
};
</script>
